import { z } from 'zod';
/**
 * The stable error codes clients branch on (`patterns/error-handling.md`, 2).
 * Never branch on the message or the HTTP status alone.
 */
export const ERROR_CODES = [
    'UNAUTHENTICATED',
    'ACCOUNT_RESTRICTED',
    'PERMISSION_DENIED',
    'NOT_FOUND',
    'VALIDATION_FAILED',
    'RULE_BLOCKED',
    'CONFLICT',
    'RATE_LIMITED',
    'ASSISTANT_UNAVAILABLE',
    'INTERNAL',
];
export const errorCodeSchema = z.enum(ERROR_CODES);
/** The HTTP status each code is returned with (`patterns/error-handling.md`, 2). */
export const ERROR_STATUS = {
    UNAUTHENTICATED: 401,
    ACCOUNT_RESTRICTED: 403,
    PERMISSION_DENIED: 403,
    NOT_FOUND: 404,
    VALIDATION_FAILED: 422,
    RULE_BLOCKED: 409,
    CONFLICT: 409,
    RATE_LIMITED: 429,
    ASSISTANT_UNAVAILABLE: 403,
    INTERNAL: 500,
};
export const errorFieldSchema = z.object({
    /** Follows the request body's shape, e.g. `domains.0`. */
    path: z.string(),
    message: z.string(),
});
/**
 * The `RULE_BLOCKED` reasons (`patterns/error-handling.md`, 2). Each
 * feature adds its own reasons here. The first reasons ship with website
 * setup.
 */
export const RULE_BLOCKED_REASONS = [
    'SELF_REMOVAL',
    'OWN_USERS_AND_PERMISSIONS',
    'LAST_USERS_AND_PERMISSIONS_HOLDER',
    'PLAN_WEBSITE_LIMIT',
    'PLAN_USER_LIMIT',
    'PLAN_PAGE_LIMIT',
    'PLAN_CUSTOM_PAGE_LIMIT',
    'INDUSTRY_STEP_INCOMPLETE',
    // A paid plan, for a new website or a move up (`docs/paddle-payments.md`, Paid plans).
    'UNPAID_INVOICES',
    'CARD_REQUIRED',
    'CARD_FAILING',
    // The card invoices are charged to can be replaced, never removed.
    'DEFAULT_CARD',
    // Integrations come with paid plans; a website has at most a few endpoints.
    'PLAN_EXCLUDES_INTEGRATIONS',
    'WEBHOOK_ENDPOINT_LIMIT',
    // Slack: a website posts to a few channels, through this Groundly's Slack app.
    'SLACK_CONNECTION_LIMIT',
    'SLACK_NOT_CONFIGURED',
    // CRMs: a website syncs to a few connections, through this Groundly's CRM apps.
    'CRM_CONNECTION_LIMIT',
    'HUBSPOT_NOT_CONFIGURED',
    'SALESFORCE_NOT_CONFIGURED',
    'ZOHO_NOT_CONFIGURED',
    // A full refund is for a yearly plan paid for within the last 14 days.
    'REFUND_NOT_AVAILABLE',
];
export const ruleBlockedReasonSchema = z.enum(RULE_BLOCKED_REASONS);
export const errorResponseSchema = z.object({
    error: z.object({
        code: errorCodeSchema,
        message: z.string(),
        /**
         * Set only for `RULE_BLOCKED`. The typed list lives in
         * `RULE_BLOCKED_REASONS` above.
         */
        reason: z.string().nullable(),
        fields: z.array(errorFieldSchema).nullable(),
        /** Matches the `X-Request-Id` header, which every response carries. */
        requestId: z.string(),
    }),
});
/** The header every response carries (`patterns/error-handling.md`, 1). */
export const REQUEST_ID_HEADER = 'X-Request-Id';
//# sourceMappingURL=errors.js.map